import React from "react";
import { connect } from "react-redux";
import Modal from "./Modal";
import { Translate, I18n } from "react-redux-i18n";
import * as actions from "../redux/actions/marketStoreFollowersActions";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import "./styles/ModalStoreFollowers.css";
import MiniLoader from "./MiniLoader";
import { FaUsers } from "react-icons/fa";

function getInitial(name) {
  return (name || "")
    .replace(/\s+/, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join("");
}

class FollowerItem extends React.Component {
  render() {
    const { item, onToggleFollow } = this.props;

    return (
      <div className="store-followers-modal-item">
        {item.Avatar ? (
          <img
            src={item.Avatar}
            className="store-followers-modal-avatar"
            alt={item.Name}
          />
        ) : (
          <span className="store-followers-modal-initials">
            {getInitial(item.Name)}
          </span>
        )}

        <div className="store-followers-modal-info">
          <p className="store-followers-modal-name">{item.Name}</p>
          {item.HasStore && (
            <p className="store-followers-modal-meta">
              <Translate value="marketstore_followers_has_store" />
            </p>
          )}
        </div>

        {item.HasStore && (
          <div className="store-followers-modal-action">
            <button
              type="button"
              className={`store-followers-modal-btn ${
                item.IsFollow
                  ? "store-followers-modal-btn--unfollow"
                  : "store-followers-modal-btn--follow"
              }`}
              onClick={() => onToggleFollow(item)}
            >
              <Translate
                value={
                  item.IsFollow ? "marketstore_unfollow" : "marketstore_follow"
                }
              />
            </button>
          </div>
        )}
      </div>
    );
  }
}

class ModalStoreFollowers extends React.Component {
  onToggleFollow = async (item) => {
    try {
      await this.props
        .UpdateFollow(this.props.token, {
          store_id: item.StoreId,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { followerList, loading } = this.props;
    const count = followerList?.length || 0;

    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        title={<Translate value="marketstore_followers" />}
      >
        <div className="store-followers-modal">
          {!loading && count > 0 && (
            <p className="store-followers-modal-subtitle">
              {count} <Translate value="marketstore_followers" />
            </p>
          )}

          {loading ? (
            <div className="store-followers-modal-loading">
              <MiniLoader />
            </div>
          ) : count === 0 ? (
            <div className="store-followers-modal-empty">
              <div className="store-followers-modal-empty-icon">
                <FaUsers />
              </div>
              <p className="store-followers-modal-empty-title">
                <Translate value="marketstore_followers_empty_title" />
              </p>
              <p className="store-followers-modal-empty-text">
                <Translate value="marketstore_followers_empty_text" />
              </p>
            </div>
          ) : (
            <div className="store-followers-modal-list">
              {followerList.map((item) => (
                <FollowerItem
                  item={item}
                  key={item.Id}
                  onToggleFollow={this.onToggleFollow}
                />
              ))}
            </div>
          )}

          <div className="store-followers-modal-footer">
            <button
              type="button"
              className="store-followers-modal-close"
              onClick={this.props.onClose}
            >
              <Translate value="close" />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(reducers) {
  return {
    user_id: reducers.session.auth.id,
    token: reducers.session.auth.access_token,
    error: reducers.marketstoreFollowers.error,
    loading: reducers.marketstoreFollowers.loading,
    followerList: reducers.marketstoreFollowers.list,
  };
}

const mapDispatchToProps = (dispatch) => ({
  UpdateFollow: (token, params) =>
    dispatch(actions.updateItem({ token, params })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalStoreFollowers);
